import * as React from "react";
import arrow_gray from "../../images/arrow_gray.gif";
import nav_closed from "../../images/nav_closed.gif";

interface Props {
  country: string;
}

const BOListTemplates: React.FC<Props> = (props) => {
  const { country } = props;

  const boListTemplate = (address: string, desc: string) => {
    return (
      <div>
        <div className="inline" style={{ marginTop: 10 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 140, marginTop: 10 }}>
          <a href={address}>{desc}</a>
        </div>
        <br className="clearBoth" />
      </div>
    );
  };

  const japanTemplate = () => {
    return (
      <div>
        <div className="inline" style={{ marginTop: 10 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120, marginTop: 10 }}>
          Relief at source
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginLeft: 10 }}>
          <img src={nav_closed} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120 }}>
          <a href="https://www.clearstream.com/caas/v1/media/3813366/data/65b0ffc54b7aba236f1ebe9d005b987d/bol-template-jp-pb-convbonds.xlsx">
            Payment breakdown for Convertible bonds
          </a>
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginLeft: 10 }}>
          <img src={nav_closed} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120 }}>
          <a href="https://www.clearstream.com/caas/v1/media/3813364/data/ca603dec6dee166e21319860f2fe601b/bol-template-jp-relief-equities.xlsx">
            Relief at source on Japanese equities
          </a>
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginTop: 10 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120, marginTop: 10 }}>
          Standard Refund
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginLeft: 10 }}>
          <img src={nav_closed} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120 }}>
          <a href="https://www.clearstream.com/caas/v1/media/3813362/data/62e1e1c8d170f977a83e26fb7a36a89e/bol-template-jp-refund-equities.xlsx">
            Tax refund request on Japanese listed equities
          </a>
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginLeft: 10 }}>
          <img src={nav_closed} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 120 }}>
          <a href="https://www.clearstream.com/caas/v1/media/3815800/data/04a0f1b44d48499398d2a2c53fd8c6c6/bol-template-jp-refund-convbonds.xlsx">
            Tax refund request on Japanese Convertible bonds
          </a>
        </div>        
        <br className="clearBoth" />
      </div>
      
    );
  };

  return (
    <div>
      <p style={{ fontWeight: "bold", marginTop:"20px" }}>
        B.O. List Templates
      </p>
      {country === "Germany" && (
        <div>
          {boListTemplate(
            "https://www.clearstream.com//caas/v1/media/3813360/data/2cba0eacb9f4c0f3b08bd0d4ef790c9e/bol-template-de-taxvoucher.csv",
            "German Tax Voucher"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/3813358/data/edb465be3003135bc1fcabc92278b0af/bol-template-de-taxbreakdown.csv",
            "German Tax Breakdown"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/3813356/data/ef6fe3ebd02df94c48dbf72b0697a05d/bol-template-de-reportingstandinginstruction-stg.csv",
            "Reporting Standing Instruction InvStG"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/1525676/data/555e77aed074d2ac543418bfd520a821/customer-declaration-english.pdf",
            "Standing Instruction Customer Declaration Template for Clearstream Europe AG (English-for information only)"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/1525680/data/a2985f22bbe31d0c68e4576336e02aab/customer-declaration-german.pdf",
            "Standing Instruction Customer Declaration Template for Clearstream Europe AG (German)"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/1317690/data/5c8a89c6663fd003e9ae9bb4b609f2d6/tgeger-otcd-cbl.pdf",
            "Tax Voucher Customer Declaration Template for Clearstream Banking S.A. (English)"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/1317684/data/a48bca416946ae051cd10e713737cd9d/tgeger-otcd-ceu-english.pdf",
            "Tax Voucher Customer Declaration Template for Clearstream Europe AG (English)"
          )}
          {boListTemplate(
            "https://www.clearstream.com/caas/v1/media/1317676/data/3811d4e69a176df32abc9b796635c535/tgeger-otcd-ceu-german.pdf",
            "Tax Voucher Customer Declaration Template for Clearstream Europe AG (German)"
          )}
        </div>
      )}
      {country === "Italy" &&
        boListTemplate(
          "https://www.clearstream.com/caas/v1/media/3813372/data/4450c699ea51e9b5f5020371099b4ece/bol-template-italy-equities.xlsx",
          "Italian equities breakdown 	"
        )}
      {country === "Japan" && <>{japanTemplate()} </>}
      {country === "South Korea" &&
        boListTemplate(
          "https://www.clearstream.com/caas/v1/media/3813370/data/d6bc1ef9abbe19fd437c4e2ae67825ca/bol-template-southkorea-drs.xlsx",
          "South Korean Depository Receipts"
        )}
      {country === "Spain" &&
        boListTemplate(
          "https://www.clearstream.com/caas/v1/media/3813374/data/28e6035c228960abcc3f2b89492a905d/bol-template-spain-standardrefund.xlsx",
          "Spanish securities - Standard refund"
        )}
      {country === "Singapore" &&
        boListTemplate(
          "https://www.clearstream.com/caas/v1/media/3813368/data/0ff3ca217de700580abac40aebd16d60/bol-template-singapore-reits.xlsx",
          "Tax refund request on Singapore REITs"
        )}
    </div>
  );
};

export default BOListTemplates;



//only to follow 